export const Figure = 'figure';
//# sourceMappingURL=figure.js.map